export default __webpack_public_path__ + "static/media/langer_bus_gadets.1dfc5356.jpg";